<script setup lang="ts">
import { useSlots } from 'vue'

import HelpIcon from '@/assets/icons/help.svg?component'
import { FlexComponent, TypographyComponent } from '@/ui-library'
import type { TypographyVariantsType } from '@/ui-library/types/ui'

withDefaults(defineProps<{ title?: string; variant?: TypographyVariantsType }>(), { variant: 'title-large' })
defineSlots<{ title(): void; tooltip(): void }>()

const slots = useSlots()
</script>
<template>
  <FlexComponent :gap="8" align="center">
    <slot v-if="$slots.title" name="title" />
    <TypographyComponent v-else :variant="variant">{{ title }}</TypographyComponent>
    <el-tooltip v-if="slots.tooltip" placement="top" effect="light" :show-arrow="false">
      <el-icon :size="18" class="tooltip-handle">
        <HelpIcon />
      </el-icon>
      <template #content>
        <slot name="tooltip" />
      </template>
    </el-tooltip>
  </FlexComponent>
</template>
<style lang="scss" scoped>
.tooltip-handle {
  cursor: pointer;
}
</style>
